import { defineStore } from "pinia";
import { computed } from "@vue/composition-api";
import storeInstance from "@/store";
import { Country } from "@core/logic/common/common";

// TODO: Переписать на pinia
export const useUser = defineStore("profile/user", () => {
  const profile = computed(() => storeInstance.state[storeInstance.getters.role].profile || {});
  const user = computed(() => profile.value.user);
  const countries = computed(() => user.value.countries.length ? user.value.countries.map(({ id }: Country) => id) : null);

  return {
    user,
    countries
  };
});